import React, { useState, useEffect } from "react";
import "../../../node_modules/swiper/swiper.min.css";
import axios from "axios";
import { useRouter } from "next/router";
import Head from "next/head";
import striptags from "striptags";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import PageNotFound from "../../pages/404";

const ServiceBanne = dynamic(() =>
  import("../../components/Service/ServiceBanne")
);
const OverviewSection = dynamic(() =>
  import("../../components/Service/OverviewSection")
);
const CounterSection = dynamic(() =>
  import("../../components/Service/CounterSection")
);
const HireProcess = dynamic(() =>
  import("../../components/Service/HireProcess")
);
const DataAnalytics = dynamic(() =>
  import("../../components/Service/DataAnalytics")
);
const ArtificialIntelligence = dynamic(() =>
  import("../../components/Service/ArtificialIntelligence")
);
const DataScience = dynamic(() =>
  import("../../components/Service/DataScience")
);
const BenefitsService = dynamic(() =>
  import("../../components/Service/BenefitsService")
);
const CategoryIndustrySolution = dynamic(() =>
  import("../Service/CategoryIndustrySolution")
);
const ChooseUS = dynamic(() => import("../../components/Service/ChooseUS"));
const WhyQuixom = dynamic(() => import("../../components/Service/WhyQuixom"));
const FrameWork = dynamic(() => import("../../components/Service/FrameWork"));
const DevelopAppSection = dynamic(() =>
  import("../../components/Service/DevelopAppSection")
);
const StrategicPartnership = dynamic(() =>
  import("../../components/Service/StrategicPartnership")
);
const TechnologyUse = dynamic(() =>
  import("../../components/Service/TechnologyUse")
);
const TechnologyStack = dynamic(() =>
  import("../../components/Service/TechnologyStack")
);
const CaseStudyBlock = dynamic(() =>
  import("../../components/Service/CaseStudyBlock")
);
const FaqSection = dynamic(() => import("../../components/Service/FaqSection"));
const ServiceArticle = dynamic(() =>
  import("../../components/Service/ServiceArticle")
);
const OurSpecialities = dynamic(() =>
  import("../../components/Service/OurSpecialities")
);
const IndustrySolutionSection = dynamic(() =>
  import("../../components/Service/IndustrySolutionSection")
);
const WorkProcessSEction = dynamic(() =>
  import("../../components/Service/WorkProcessSEction")
);
const CtaGradient = dynamic(() =>
  import("../../components/Service/CtaGradient")
);
const AnalyticsAndInfraStructure = dynamic(() =>
  import("../../components/Service/AnalyticsAndInfraStructure")
);
const OurOfferingSection = dynamic(() =>
  import("../../components/Service/OurOfferingSection")
);

const Loader = dynamic(() => import("../../components/common/Loader/Loader"));
const Layout = dynamic(() => import("../../components/common/Layout/Layout"));
const CommonCtaSection = dynamic(() =>
  import("../../components/common/CTASection/CommonCtaSection")
);
const CategoryBanner = dynamic(() => import("./CategoryBanner"));


const ServiceLandingPage = ({ apiData }) => {
  const router = useRouter();
  const slug = router?.query?.slug;
  const [showAllFaqs, setShowAllFaqs] = useState(true);
  const [articleData, setArticleData] = useState();
  const [serviceDetail, setServiceDetail] = useState();
  const [loader, setLoader] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [activeItem, setActiveItem] = useState(0);
  const [aiShow, setAiShow] = useState(false);
  const title = apiData?.page_title;
  const seo_title = apiData?.meta?.seo_title;
  const canonicalUrl = apiData?.canonical_url;
  const og_title = apiData?.og_title;
  const og_description = apiData?.og_description;
  const og_image = apiData?.og_image?.url;
  const search_description = apiData?.meta?.search_description;


  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const footerData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );

  const structuredData = apiData?.struct_org_extra_json;
  const formatJson = (json) => {
    return {
      __html: `${json}`,
    };
  }

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await axios.get(
          process.env.NEXT_PUBLIC_API_ENDPOINT + "/blog/list"
        );
        const data = response?.data && response?.data?.latest_articles;
        data && setArticleData(data);
      } catch (error) {
        console.log("Error fetching articles", error);
      }
    };
    fetchArticles();
  }, []);

  const fetchData = async () => {
    try {
      const data = apiData.detail;
      data && setServiceDetail(data);
      setLoader(false);
      if (footerData && data) {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log("errrerror fetchData", error);
    }
  };

  useEffect(() => {
    // Check if the type is "ai_section" and set the state accordingly
    const hasAiSection =
      serviceDetail && serviceDetail.some((item) => item.type === "ai_section");
    setAiShow(hasAiSection);
  }, [serviceDetail]);

  useEffect(() => {
    fetchData();
  }, [slug]);

  return (
    <>
      <Head>
        <title>{striptags(title)}</title>

        <meta name="title" content={seo_title} key="og-title" />

        <meta name="description" content={search_description} key="og-desc" />

        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={og_title || seo_title} />
        <meta property="og:description" content={og_description || search_description} />
        <meta property="og:image" content={og_image} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Quixom" />

        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={formatJson(structuredData)}
          />
        )}

      </Head>

      {loader && <Loader />}
      <main
        className="main-wrapper services-detail-middle wrapper-top-bg"
        style={{ background: "#f6fbfd" }}
      >
        <article className="wrapper-inner">
          {serviceDetail ? (
            serviceDetail?.map((val, index) => {
              switch (val?.type) {
                case "service_banner":
                  return <CategoryBanner key={index} serviceDetail={val} />;
                case "service_type":
                  return <CategoryIndustrySolution key={index} serviceDetail={val} />;
                case "service_overview":
                  return <OverviewSection key={index} serviceDetail={val} />;
                case "counter_section":
                  return <CounterSection key={index} serviceDetail={val} />;
                case "hire_process":
                  return <HireProcess key={index} serviceDetail={val} />;
                case "data_analytics_section":
                  return <DataAnalytics key={index} serviceDetail={val} />;
                case "analytics_and_infrastructure":
                  return (
                    <AnalyticsAndInfraStructure
                      key={index}
                      serviceDetail={val}
                    />
                  );
                case "ai_section":
                  return (
                    <ArtificialIntelligence
                      key={index}
                      serviceDetail={val}
                      aiShow={aiShow}
                    />
                  );
                case "data_science":
                  return <DataScience key={index} serviceDetail={val} />;
                case "benefits_services":
                  return <BenefitsService key={index} serviceDetail={val} />;
                case "choose_us_services":
                  return <ChooseUS key={index} serviceDetail={val} />;
                case "why_hire":
                  return <ChooseUS key={index} serviceDetail={val} />;
                case "why_quixom_services":
                  return <WhyQuixom key={index} serviceDetail={val} />;
                case "framework":
                  return <FrameWork key={index} serviceDetail={val} />;
                case "develop_app_section":
                  return (
                    <DevelopAppSection key={index} serviceDetail={val} />
                  );
                case "strategic_partnership":
                  return (
                    <StrategicPartnership key={index} serviceDetail={val} />
                  );
                case "technology_use":
                  return <TechnologyUse key={index} serviceDetail={val} />;
                case "cta_gradient":
                  return <CtaGradient key={index} serviceDetail={val} />;
                case "specialities":
                  return <OurSpecialities key={index} serviceDetail={val} />;
                case "work_process":
                  return (
                    <WorkProcessSEction key={index} serviceDetail={val} />
                  );
                case "technology_stack":
                  return <TechnologyStack key={index} serviceDetail={val} />;
                case "solutions":
                  return (
                    <IndustrySolutionSection
                      key={index}
                      serviceDetail={val}
                    />
                  );
                case "outcomes":
                  return <CaseStudyBlock key={index} serviceDetail={val} />;

                case "case_studies_block":
                  return <CaseStudyBlock key={index} serviceDetail={val} />;
                case "offering":
                  return (
                    <OurOfferingSection key={index} serviceDetail={val} />
                  );
                case "faq":
                  return (
                    <FaqSection
                      key={index}
                      serviceDetail={val}
                      showAllFaqs={showAllFaqs}
                      activeindex={activeItem}
                      setShowAllFaqs={() => {
                        setShowAllFaqs(true);
                      }}
                    />
                  );
                case "articles":
                  return <ServiceArticle key={index} serviceDetail={val} />;
                case "cta":
                  return <CommonCtaSection key={index} data={val} />;
                // Add more cases for other section types if needed
                default:
                  return null;
              }
            })
          ) : (
            <PageNotFound />
          )}
        </article>
      </main>
    </>
  );
};


export default ServiceLandingPage;
